import React,{useState,useEffect} from 'react';
import { useLocation,useHistory } from 'react-router-dom';
import { Button,TextField,CircularProgress,RadioGroup,FormControlLabel,FormControl,FormLabel,Radio,makeStyles} from '@material-ui/core';
import Rating from '../Components/Reseñas/Rating';
import Alert from '../Components/Alert';
import axios from 'axios';

import styled from "styled-components";
import fondoArriba from "../assets/imgs/Reseñas/Encuesta_top.jpg"
import fondoAbajo from "../assets/imgs/Reseñas/Encuesta_bottom.jpg"

import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';

import { obtenerFecha } from '../Utils/Dates';

const useStyles = makeStyles(() => ({
    group: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      width:"100%",
      justifyContent:"space-around"
    },  
    check:
    {   
        margin:"0"
    },
    container: {
        display: 'flex',
        overflowX: 'auto',
        whiteSpace: 'nowrap',
        height: '200px',
        backgroundColor: 'lightblue',
    },
}));

const Container = styled.div`
border-radius:10px;
overflow-x:"";
min-width:320px;
width:670px;
max-width:90vw;
padding:24px;
margin:10px;
border:1px solid black;`;

const ContainerForm = styled.div`
height:100%;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;`;

const ContainerImageCenter = styled.div`
background-color:#ded9ce;
height:100%;`;


const ContainerOpinions = styled.div``;

const ItemHeader = styled.div`
display: grid;
grid-template-columns:20% auto auto auto;
align-items:center;
margin:0;`;

const Item = styled.div`
display: grid;
grid-template-columns:20% auto;
margin:0;`;

const Title = styled.p`
word-wrap: break-word;
width: 100%;
margin:0px;

@media (max-width:367px){
    font-size:13px;
}`;


const HeaderPuntaje = styled.p`
word-wrap: break-word;
margin:0px;
text-align:center;

@media (max-width:367px){
    font-size:13px;
}
`;

const TitleEnded = styled.p`
margin:0px;
text-align:center;`;

const Fondo = ({children}) => {

    const History = useHistory();

    const goToHome = () => 
    {
        History.push("/");
    }

    return (
      <div style={{ display: 'flex', flexDirection: 'column', height: '100vh'}}>
        <img src={fondoArriba} onClick={goToHome} alt="Fondo arriba" style={{ width: '100%', border: 'none'}}/>

        <ContainerImageCenter>
            <ContainerForm> {children} </ContainerForm>
        </ContainerImageCenter>
    
        <img src={fondoAbajo} alt="Fondo abajo"style={{ width: '100%'}}/>
      </div>
    );
};

const Reseña = () =>
{
    const classes = useStyles();

    const [noScroll, setNoScroll] = useState(false);

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const Mesa = searchParams.get('t');


    const [Bebida, setBebida] = useState(undefined);
    const [Comida, setComida] = useState(undefined);
    const [Atencion, setAtencion] = useState(undefined);
    const [Ambientacion, setAmbientacion] = useState(undefined);
    const [Telefono, setTelefono] = useState("");
    const [Sugerencia, setSugerencia] = useState("");

    const [ShowCupon, setShowCupon] = useState(undefined);
    const [ShowRepeatClient, setShowRepeatClient] = useState(undefined);

    const [isLoading, setisLoading] = useState(false)
    const [showAlert, setshowAlert] = useState("");
    const [typeAlert, settypeAlert] = useState("");
    const [Cupon, setCupon] = useState(undefined);



    useEffect(() => 
    {
        const handleResize = () => {
          if (window.innerWidth < 470) { // Cambia aquí el valor de anchura mínima deseado
            setNoScroll(false);
          } else {
            setNoScroll(true);
          }
        };
    
        handleResize();
    
        window.addEventListener('resize', handleResize);
    
        return () => {
          window.removeEventListener('resize', handleResize);
        };
    }, []);

    const changeValue = (event,key) =>
    {
        key(event.target.value);
    }

    const Submit = async () =>
    {
        setisLoading(true);

        if( isNaN(Bebida) || isNaN(Comida) ||  isNaN(Atencion) ||  isNaN(Ambientacion) || (Telefono !== "" && Telefono.length !== 10) )
        {
            var Mensaje = "Por favor, completá:\n";
            
            if(isNaN(Bebida))
                Mensaje += " • Bebida\n";
            if(isNaN(Comida))
                Mensaje += " • Comida\n";
            if(isNaN(Atencion))
                Mensaje += " • Atención\n";
            if(isNaN(Ambientacion))
                Mensaje += " • Ambientación\n";
            if(Telefono !== "" && Telefono.length !== 10 )
                Mensaje += " • El telefono debe tener 10 digitos";
            
            setshowAlert(Mensaje.trim());
            settypeAlert("error");
            setisLoading(false);
            return;
        }

        const Fecha = obtenerFecha();
        const Payload = {Bebida,Comida,Atencion,Ambientacion,Fecha,Telefono,Mesa,Sugerencia};

        try 
        {
            const Peticion = await window.axios.post("/review", Payload);    
            setisLoading(false);
            setCupon(Peticion.data.Cupon);
            setShowCupon(Peticion.data.ShowCupon)
            setShowRepeatClient(Peticion.data.ShowRepeatClient)

        } 
        catch (error) 
        {
            setisLoading(false);
            setshowAlert("Error al enviar la reseña");
            settypeAlert("error");
        }
    }

    const CopyClipboard = () =>
    {
        navigator.clipboard.writeText(Cupon);
        setshowAlert("Copiado al portapapeles");
        settypeAlert("success");
    }


    if(ShowCupon === true)
    {
        return <Fondo>
            <Container>
                <TitleEnded>Gracias por tu reseña! Te dejamos un cupón de 10% de descuento para <a href='https://encasa.baumlanus.com.ar' target='_blank'>nuestra tienda</a>. <br/>    <strong> {Cupon}  </strong> <FileCopyOutlinedIcon onClick={() => CopyClipboard()} style={{cursor:"pointer"}}/>  </TitleEnded>              
            </Container>
            <Alert mensaje={showAlert} close={()=>setshowAlert(false)} type={typeAlert}/>
        </Fondo>
    }


    if(ShowCupon === false && ShowRepeatClient === false)
    {
        return <Fondo>
            <Container>
                <TitleEnded>Gracias por dejarnos tu comentario.</TitleEnded>              
            </Container>
            <Alert mensaje={showAlert} close={()=>setshowAlert(false)} type={typeAlert}/>
        </Fondo>
    }


    if(ShowRepeatClient)
    {
        return <Fondo>
            <Container>
                <TitleEnded>Ya existe una reseña con ese número! Gracias por dejarnos otro comentario.</TitleEnded>              
            </Container>
            <Alert mensaje={showAlert} close={()=>setshowAlert(false)} type={typeAlert}/>
        </Fondo>
    }

  
    return <Fondo>     
        <Container>
            <p>Califica tu visita!</p>
            <ContainerOpinions>
                <ItemHeader>
                <div style={{width:"162px"}}/>
                    <HeaderPuntaje>Muy<br/>buena</HeaderPuntaje>
                    <HeaderPuntaje>Aceptable</HeaderPuntaje>
                    <HeaderPuntaje>Debe<br/>mejorar</HeaderPuntaje>
                </ItemHeader>

                <Item>
                    <Title>Bebida</Title>
                    <RadioGroup className={classes.group} value={Comida} onChange={e => changeValue(e,setBebida)} style={{margin:"0 !important"}}>
                        <FormControlLabel style={{margin:"0 !important"}} value="3" control={<Radio style={{margin:"0 !important"}} className={classes.check} />} className={classes.Control}/>
                        <FormControlLabel style={{margin:"0 !important"}} value="2" control={<Radio style={{margin:"0 !important"}} className={classes.check} />} className={classes.Control}/>
                        <FormControlLabel style={{margin:"0 !important"}} value="1" control={<Radio style={{margin:"0 !important"}} className={classes.check} />} className={classes.Control}/>
                    </RadioGroup>
                </Item>
                <Item>
                    <Title>Comida</Title>
                    <RadioGroup className={classes.group} value={Comida} onChange={e => changeValue(e,setComida)} style={{margin:"0 !important"}}>
                        <FormControlLabel style={{margin:"0 !important"}} value="3" control={<Radio style={{margin:"0 !important"}} className={classes.check} />} className={classes.Control}/>
                        <FormControlLabel style={{margin:"0 !important"}} value="2" control={<Radio style={{margin:"0 !important"}} className={classes.check} />} className={classes.Control}/>
                        <FormControlLabel style={{margin:"0 !important"}} value="1" control={<Radio style={{margin:"0 !important"}} className={classes.check} />} className={classes.Control}/>
                    </RadioGroup>

                </Item>
                <Item>
                    <Title>Atención</Title>
                    <RadioGroup className={classes.group} value={Atencion} onChange={e => changeValue(e,setAtencion)} style={{margin:"0 !important"}}>
                        <FormControlLabel style={{margin:"0 !important"}} value="3" control={<Radio  style={{margin:"0 !important"}} className={classes.check} />} className={classes.Control}/>
                        <FormControlLabel style={{margin:"0 !important"}} value="2" control={<Radio  style={{margin:"0 !important"}} className={classes.check} />} className={classes.Control}/>
                        <FormControlLabel style={{margin:"0 !important"}} value="1" control={<Radio  style={{margin:"0 !important"}} className={classes.check} />} className={classes.Control}/>
                    </RadioGroup>
                </Item>
                <Item>
                    <Title>Ambientación</Title>
                    <RadioGroup className={classes.group} value={Ambientacion} onChange={e => changeValue(e,setAmbientacion)} style={{margin:"0 !important"}}>
                        <FormControlLabel style={{margin:"0 !important"}} value="3" control={<Radio  style={{margin:"0 !important"}} className={classes.check} />} className={classes.Control}/>
                        <FormControlLabel style={{margin:"0 !important"}} value="2" control={<Radio  style={{margin:"0 !important"}} className={classes.check} />} className={classes.Control}/>
                        <FormControlLabel style={{margin:"0 !important"}} value="1" control={<Radio  style={{margin:"0 !important"}} className={classes.check} />} className={classes.Control}/>
                    </RadioGroup>
                </Item>
            </ContainerOpinions>

        </Container> 

        <Container>
            <p>¿Tienes algun comentario o sugerencia?</p>
            <TextField fullWidth multiline placeholder="Tu respuesta" variant="outlined" value={Sugerencia} onChange={e => setSugerencia(e.target.value)}/>
        </Container>  

        <Container>
            <p>Opcional: Déjanos un WhatsApp para recibir un descuento en nuestra tienda!</p>
            <TextField fullWidth type="number" placeholder="Telefono" variant="outlined" value={Telefono} onChange={e => setTelefono(e.target.value)}/>
        </Container>  

        {isLoading ? <CircularProgress size={24}/> : <Button color='black' variant='contained' fullWidth style={{width:"670px",maxWidth:"90vw",backgroundColor:"black",color:"white"}} onClick={Submit}>Enviar</Button>   }
        <Alert mensaje={showAlert} close={()=>setshowAlert(false)} type={typeAlert}/>
    </Fondo>
}

export default Reseña;